import React from "react";
import SoftBox from "components/SoftBox";
import SoftModal from "components/SoftModal";

function PrivacyPolicyModal({ open, onClose }) {
  const modalStyle = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: "60vw",
    maxHeight: "80vh",
    overflow: "auto",
    bgcolor: "#fff",
    border: "1px solid #ccc",
    boxShadow: 24,
    p: 0,
    borderRadius: 2,
  };

  const headerStyle = {
    padding: "20px 30px",
    borderBottom: "1px solid #eee",
    backgroundColor: "#f7f7f7",
    borderTopLeftRadius: 8,
    borderTopRightRadius: 8,
  };

  const contentStyle = {
    padding: "30px",
    fontSize: "14px",
    color: "#333",
    lineHeight: 1.7,
    backgroundColor: "#fff",
  };

  const sectionTitleStyle = {
    fontSize: "18px",
    fontWeight: "600",
    marginTop: "24px",
    marginBottom: "8px",
  };

  const subTitleStyle = {
    fontSize: "16px",
    fontWeight: "500",
    marginTop: "16px",
    marginBottom: "6px",
  };

  const listStyle = {
    paddingLeft: "20px",
    marginBottom: "12px",
  };

  const paragraphStyle = {
    marginBottom: "12px",
  };

  return (
    <SoftBox>
      <SoftModal open={open} onClose={onClose} aria-labelledby="privacy-policy-modal">
        <SoftBox sx={modalStyle}>
          <div style={headerStyle}>
            <h2 style={{ fontSize: "22px", fontWeight: "700", margin: 0 }}>Privacy Policy</h2>
          </div>
          <div style={contentStyle}>
            <h1 style={{ fontSize: "22px", fontWeight: "700", marginBottom: "20px" }}>
              SmartDirectoryAI End-User License Agreement
            </h1>

            <h2 style={sectionTitleStyle}>1. Grant of License</h2>

            <h3 style={subTitleStyle}>1.1 License Types</h3>
            <p style={paragraphStyle}>
              Depending on the plan selected at purchase, Licensee is granted either a:
            </p>
            <ul style={listStyle}>
              <li>
                <strong>Single-Site License:</strong> Allows use of the SmartDirectoryAI software
                for one (1) installation.
              </li>
              <li>
                <strong>Unlimited Site License:</strong> Allows use for multiple installations owned
                and managed by Licensee:
                <ul style={listStyle}>
                  <li>Operating multiple SmartDirectoryAI websites</li>
                  <li>Selling websites built using the software as a service</li>
                </ul>
              </li>
            </ul>

            <h3 style={subTitleStyle}>1.2 Permitted Uses</h3>
            <ul style={listStyle}>
              <li>Operate directories using SmartDirectoryAI</li>
              <li>Offer directories to clients as services</li>
              <li>Transfer sites without backend access or redistribution rights</li>
            </ul>

            <h3 style={subTitleStyle}>1.3 Prohibited Uses</h3>
            <ul style={listStyle}>
              <li>Resell or redistribute the software</li>
              <li>Allow third-party hosting or reselling</li>
              <li>Offer it as a SaaS or white-label platform</li>
              <li>Transfer license without consent</li>
            </ul>

            <h2 style={sectionTitleStyle}>2. Restrictions</h2>
            <ul style={listStyle}>
              <li>Reverse engineer or decompile the software</li>
              <li>Create derivative works</li>
              <li>Exploit the software beyond terms</li>
              <li>Develop competing software</li>
              <li>Share credentials or allow unauthorized use</li>
            </ul>

            <h2 style={sectionTitleStyle}>3. Ownership</h2>
            <p style={paragraphStyle}>
              All intellectual property rights remain with Offline Sharks, LLC. No ownership rights
              are transferred.
            </p>

            <h2 style={sectionTitleStyle}>4. Fees and Payment</h2>
            <p style={paragraphStyle}>
              Licensee must pay all agreed fees. Non-payment may lead to service termination. Fees
              are non-refundable unless stated.
            </p>

            <h2 style={sectionTitleStyle}>5. Term and Termination</h2>
            <p style={paragraphStyle}>
              This agreement remains effective until terminated. Either party may terminate.
              Licensor may suspend access in case of breach.
            </p>

            <h2 style={sectionTitleStyle}>6. Updates and Maintenance</h2>
            <p style={paragraphStyle}>
              Updates may be released at Licensor’s discretion. Custom modifications/support are not
              guaranteed.
            </p>

            <h2 style={sectionTitleStyle}>7. Disclaimer of Warranties</h2>
            <p style={paragraphStyle}>
              The software is provided “as is.” Licensor disclaims all express or implied
              warranties.
            </p>

            <h2 style={sectionTitleStyle}>8. Limitation of Liability</h2>
            <p style={paragraphStyle}>
              Licensor’s liability is limited to the total amount paid by Licensee in the last 12
              months. No responsibility for indirect damages.
            </p>

            <h2 style={sectionTitleStyle}>9. Indemnification</h2>
            <p style={paragraphStyle}>
              Licensee shall indemnify Offline Sharks, LLC from any claims, damages, or liabilities
              arising from misuse or breach.
            </p>

            <h2 style={sectionTitleStyle}>10. Data & Privacy</h2>
            <p style={paragraphStyle}>
              Licensee is responsible for compliance with data laws. Use is subject to Licensor’s
              Privacy Policy.
            </p>

            <h2 style={sectionTitleStyle}>11. Governing Law</h2>
            <p style={paragraphStyle}>
              This agreement is governed by Nevada law. Jurisdiction is with courts in Las Vegas,
              Nevada.
            </p>

            <h2 style={sectionTitleStyle}>12. Miscellaneous</h2>
            <ul style={listStyle}>
              <li>This is the entire agreement.</li>
              <li>If any part is invalid, the remainder stays effective.</li>
              <li>No assignment without written consent.</li>
            </ul>
          </div>
        </SoftBox>
      </SoftModal>
    </SoftBox>
  );
}

export default PrivacyPolicyModal;
